import { Helmet } from 'react-helmet-async';

const ListItem = ({
	boldText,
	children,
}: {
	boldText: string;
	children: React.ReactNode;
}) => (
	<p>
		<strong className="font-medium text-gray-800">{boldText}:</strong>{' '}
		{children}
	</p>
);

const BenefitTermsOfUsePage = () => {
	return (
		<main className="mx-auto w-full max-w-3xl px-4 py-12 md:py-20">
			<Helmet>
				<title>Termos de Uso do Benefício | Plumaa</title>
				<meta
					name="description"
					content="Consulte as regras de uso dos benefícios da Plumaa: validade, renovação, débito por sessão e condições de elegibilidade."
				/>
			</Helmet>

			<h1 className="mb-8 text-2xl font-bold text-gray-900 md:text-3xl">
				TERMOS DE USO DO BENEFICIO Plumaa
			</h1>

			<div className="space-y-6 text-justify text-zinc-600">
				<p>
					Este documento define as regras para utilização de
					benefícios vinculados ao plano do usuário no ecossistema
					Plumaa.
				</p>

				<h2 className="pt-6 text-2xl font-semibold text-gray-800">
					1. Elegibilidade e Vinculo
				</h2>
				<ListItem boldText="1.1. Titularidade">
					O benefício é pessoal, intransferível e associado à conta
					ativa do usuário.
				</ListItem>
				<ListItem boldText="1.2. Compatibilidade de serviço">
					O benefício somente pode ser aplicado em serviços elegíveis
					definidos na assinatura contratada.
				</ListItem>

				<h2 className="pt-6 text-2xl font-semibold text-gray-800">
					2. Validade e Renovação
				</h2>
				<ListItem boldText="2.1. Ciclo de uso">
					O saldo de benefício segue o ciclo do plano vigente, com
					renovação conforme as regras comerciais contratadas.
				</ListItem>
				<ListItem boldText="2.2. Regras de expiração">
					Benefícios não utilizados podem expirar ao final do ciclo,
					conforme condições da assinatura.
				</ListItem>

				<h2 className="pt-6 text-2xl font-semibold text-gray-800">
					3. Debito e Confirmacao
				</h2>
				<ListItem boldText="3.1. Uso no pagamento">
					Ao confirmar o pagamento com benefício, uma unidade elegível
					é debitada do saldo disponível.
				</ListItem>
				<ListItem boldText="3.2. Momento do debito">
					O débito ocorre durante a confirmação do
					agendamento/pagamento, respeitando a disponibilidade no
					momento da transação.
				</ListItem>

				<h2 className="pt-6 text-2xl font-semibold text-gray-800">
					4. Limitacoes e Responsabilidades
				</h2>
				<ListItem boldText="4.1. Indisponibilidade de saldo">
					Se não houver saldo elegível, o pagamento deverá ocorrer por
					outro meio disponível na plataforma.
				</ListItem>
				<ListItem boldText="4.2. Alterações">
					A Plumaa poderá atualizar estas regras para adequação
					técnica, operacional ou legal, preservando transparência ao
					usuário.
				</ListItem>
			</div>
		</main>
	);
};

export default BenefitTermsOfUsePage;
